import { env } from "@gui/infrastructure/pass-through/env";

export const AppVersion = () => {
	return <div className="appVersion">{env.appVersion}</div>;
};
